(function () {
    var ClefVerteModule = angular.module('ClefVerteModule', ['ui.bootstrap', 'ui.select', 'ngSanitize', 'ngCookies', 'vcRecaptcha']);
})();
